import {Participant} from './app/shared'
import { SiteConfig } from './app/shared';

export interface SelfRegExt {
   /**
    * When the registration form is presented this function is called to
    * provide an opportunity to set default field values on the initial
    * participant object used to populate the form.
    * @param p Initial participant object populated with minimum required fields (wristband ID, event ID, etc)
    * @returns Returns the participant object after setting extra default field values
    */
   participantInit?(p:Participant):Participant;

   /**
    * Override the default (linear) registration form page navigation. This
    * function is called when the user clicks the continue button in the
    * registation form, and the site needs to decide which form to go to next.
    * @param index Current page index (zero is the first form page)
    * @param p Current participant object populated from form pages so far
    * @returns Form page to navigate to, or null to submit form and finish registration
    */
   navigate?(index:number,p:Participant):number;

   /**
    * Called when the form page changes.
    * @param index Current page index (zero is the first form page)
    * @param p Current participant object populated from form pages so far
    * @param c Site config object
    */
   pageChange?(index:number,p:Participant,c:SiteConfig):void;
}

declare global {
   var selfRegExt:SelfRegExt;
}

globalThis.selfRegExt = {};
